// Rebuilt only on Sigma processing (topology/layout/filter changes), never pan/zoom.
// Camera passes query occupied framed-coordinate cells, then eligibility, then
// project only eligible visible candidates to CSS pixels.
export function createLabelIndex(renderer, graph) {
  let cells=new Map(), priority=new Set();
  const rebuild=()=>{
    cells=new Map(); priority=new Set();
    graph.forEachNode(id=>{
      const d=renderer.getNodeDisplayData(id); if(!d||d.hidden)return;
      const key=Math.floor(d.x*64)+":"+Math.floor(d.y*64);
      if(!cells.has(key))cells.set(key,[]);
      cells.get(key).push(id); if(d.highlighted)priority.add(id);
    });
  };
  renderer.on("afterProcess",rebuild);
  return { query(width,height){
    const points=[[0,0],[width,0],[0,height],[width,height]].map(([x,y])=>renderer.viewportToFramedGraph({x,y}));
    const xs=points.map(p=>Math.floor(p.x*64)),ys=points.map(p=>Math.floor(p.y*64));
    const minX=Math.min(...xs)-1,maxX=Math.max(...xs)+1,minY=Math.min(...ys)-1,maxY=Math.max(...ys)+1;
    const ids=new Set(priority);
    for(const [key,members] of cells){const [x,y]=key.split(":").map(Number);if(x>=minX&&x<=maxX&&y>=minY&&y<=maxY)for(const id of members)ids.add(id);}
    return ids;
  },kill(){renderer.off("afterProcess",rebuild);},rebuild };
}
